import React from 'react'
import styleIcon from './Icon.module.scss'
import { IconViewProps } from './useIcon'

export const IconView = (props: IconViewProps): JSX.Element => {
  const { size, view }: IconViewProps = props

  return (
    !!view && (
      <div
        className={styleIcon._}
        style={{
          width: size,
          height: size
        }}
      >
        {view}
      </div>
    )
  )
}
